module.exports = __webpack_public_path__ + "img/icon_benefit4@3x.fcbe2e33.png";